import { ThankYouTemplate } from 'components/organisms/ThankYouTemplate/ThankYouTemplate';
import { ThankYouPageContentType } from 'components/organisms/ThankYouTemplate/ThankYouTemplate.enums';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface INextActionContent {
  numberOfNotCompletedActions: number;
  exitUrl: string;
  companyName: string;
  companyLogoUrl?: string;
}

const NextActionContent: FC<INextActionContent> = ({
  numberOfNotCompletedActions,
  exitUrl,
  companyName,
  companyLogoUrl,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNextActionClick = () => {
    navigate(exitUrl);
  };

  const mainText = t(
    'stage.testCallback.goodProgressYouHaveNumberOfTestRemaining',
    { testCount: numberOfNotCompletedActions }
  );

  return (
    <ThankYouTemplate
      mainText={mainText}
      onClick={handleNextActionClick}
      contentType={ThankYouPageContentType.NEXT_TEST_CONTENT}
      companyLogoUrl={companyLogoUrl}
      companyName={companyName}
    />
  );
};

export default NextActionContent;
